import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, input, OnInit, viewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonComponent, ButtonDirective } from '@progress/kendo-angular-buttons';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridComponent, GridModule } from '@progress/kendo-angular-grid';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { PagerInfoComponent, PagerNextButtonsComponent, PagerNumericButtonsComponent, PagerPrevButtonsComponent } from '@progress/kendo-angular-pager';
import { PxdGridMenuComponent } from '../pxd-grid-menu/pxd-grid-menu.component';

@Component({
  selector: 'pxd-grid-default',
  templateUrl: './pxd-grid-default.component.html',
  styleUrls: ['./pxd-grid-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AsyncPipe,
    ButtonComponent,
    ButtonDirective,
    DropDownListComponent,
    ExcelModule,
    FormsModule,
    GridModule,
    LoaderComponent,
    NumericTextBoxComponent,
    PagerInfoComponent,
    PagerNextButtonsComponent,
    PagerNumericButtonsComponent,
    PagerPrevButtonsComponent,
    PxdGridMenuComponent,
    ReactiveFormsModule,
  ],
})
export class PxdGridDefaultComponent implements OnInit, AfterViewInit {
  private readonly grid = viewChild(GridComponent);

  readonly form = input<UntypedFormGroup>(undefined);
  readonly columns = input<PxdColumns[]>(undefined);
  readonly data = input<any>(undefined);
  readonly config = input<any>(undefined);
  readonly columnSettingsKey = input<string>(undefined);
  readonly lockSelectionCheckbox = input<boolean>(undefined);

  public icons = kendoIcons;
  public svc: any;
  public canCreateNewRow: boolean;

  public ngOnInit() {
    this.svc = this.config().service;
    this.canCreateNewRow = this.config().canCreateNewRow || false;
  }

  public ngAfterViewInit() {
    this.svc.grid = this.grid();
  }

  public pageSizeChange(e: any) {
    if (e.target.value !== null) {
      this.svc.gridState.take = e.target.value;
      this.svc.gridState.skip = 0;
      this.grid().notifyPageChange('pxdGrid', this.svc.gridState);
    }
  }
}